import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * PDF Editor Module Service Stores
 */
export const pdfEditorStores: ServiceStoreConfig[] = [
  {
    name: "pdf-documents",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "pdf-annotations",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "pdf-templates",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "pdf-storage",
    options: { enableStorage: false, enableErrorNotifications: false },
  },
  {
    name: "pdf-shares",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "pdf-document-shares",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "pdf-collaborators",
    options: { enableStorage: false, enableErrorNotifications: false },
  },
];